export const OTP_LENGTH = 4;
export const COUNTDOWN_SECONDS = 600;

export const STEP = {
    SELECT_METHOD: "selectMethod",
    VERIFY_OTP: "verifyOtp",
    SET_NEW_PASSWORD: "setNewPassword",
  };